/* eslint-disable import/prefer-default-export */

export const USED = 'used';
export const USED_LICENSING = 'user-licensing';
